import React, {useCallback} from 'react';
import PopupInjector from '@src/components/Popup/PopupInjector';
import AddNewTokenPopup from '@views/external-applications/fields/AddNewTokenPopup';

type PopupInjectorParams = Parameters<React.ComponentProps<typeof PopupInjector>['renderButton']>;

export default function AddNewTokenButton(props: {
    isDisabled?: boolean,
} & Omit<React.ComponentProps<typeof AddNewTokenPopup>, 'closePopup'>) {
    const {isDisabled} = props;

    const buttonRenderer = useCallback(({openPopup}: PopupInjectorParams[0]): React.ReactNode => {
        return <button
                type="button"
                className="btn btn-sm btn-outline-success me-1"
                disabled={isDisabled}
                onClick={openPopup}
        >
            <i className="fa fa-plus"/>
        </button>;
    }, [isDisabled]);

    return <PopupInjector
            popupName="add-external-app-token-popup"
            renderPopup={params => <AddNewTokenPopup {...params} {...props}/>}
            renderButton={buttonRenderer}
    />;
}
